import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import Form from "../../components/Form/Form";
import { useFormConfig } from "./CourseFieldsConfig";
import { addCourse, updateCourse } from "../../services/CourseService";
import { useLocation } from "react-router-dom";

function CourseForm({ onClose, onFormSubmit }) {
  const toast = useRef(null);
  const { courseForm } = useFormConfig();
  const location = useLocation();
  const { mode, course } = location.state || {};

  const [formData, setFormData] = useState(courseForm.initialFormData);

  useEffect(() => {
    if (mode === "update" && course) {
      setFormData({
        title: course.title || "",
        categoryId: course.category_id || null,
        roleId: course.role_ids || [],
        publishDate: course.published_date ? new Date(course.published_date) : null,
        startDate: course.start_date ? new Date(course.start_date) : null,
        endDate: course.end_date ? new Date(course.end_date) : null,
      });
    } else {
      setFormData(courseForm.initialFormData);
    }
  }, [mode, course]);

  const handleSubmit = async (courseFormData) => {
    try {
      const response = mode === "update" && course
        ? await updateCourse(course.id, courseFormData)
        : await addCourse(courseFormData);
      if (response.status === 200 || response.status === 201) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message || "Course Submitted Successfully",
          life: 1500,
        });
        setTimeout(() => {
          onClose();
          if (onFormSubmit) onFormSubmit();
        }, 1500);
      } else {
        throw new Error(response.message || "Something went wrong");
      }
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: err.message || "Submission failed",
        life: 1500,
      });
    }
  };

  return (
    <>
    <Toast ref={toast} />
    <Form
      formTitle={courseForm.formTitle}
      initialFormData={formData}
      fieldConfig={courseForm.fieldConfig}
      onSubmit={handleSubmit}
      onClose={onClose}
      mode={mode}
    />
    </>
  );
}

export default CourseForm;
